import React, {FC, useEffect, useRef} from "react";
import {confirmBox} from "@kopjra/uikit";
import {useTranslation} from "react-i18next";

export interface Props {
    message: string;
    dark?: boolean;
    todo: () => void | Promise<void>;
}

export const NavigationPrompt: FC<Props> = ({dark, message, todo}) => {

    const {t} = useTranslation();
    const allowBack = useRef(false);

    useEffect(() => {
        // Prevent the browser from navigating away
        window.history.pushState(null, document.title, window.location.href);

        function alertUser(e: BeforeUnloadEvent)  {
            e.preventDefault();
            e.returnValue = ""; // This is necessary for some browsers to show the confirmation dialog
        }

        async function handlePopState(e: PopStateEvent) {
            if (allowBack.current) {
                return; // Allow navigation
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            if (await confirmBox({
                dark,
                message,
                yesText: t("new.yes"),
                noText: t("new.no"),
            })) {
                allowBack.current = true;
                todo();
            } else {
                window.history.pushState(null, document.title, window.location.href);// Reset the history state
            }
        }
        window.addEventListener('beforeunload', alertUser);
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('beforeunload', alertUser);
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
    return <></>;
}